import React from 'react';
import '../../../smsgateway/layout/SmsSkeleton.css';

function CategoryTreeSkeleton({ count = 4 }) {
    return (
        <div className="articles-category-list">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="articles-category-skeleton">
                    <div className="sms-skeleton" style={{ width: '24px', height: '24px', borderRadius: '6px' }} />
                    <div className="sms-skeleton flex-grow-1" style={{ height: '14px', borderRadius: '4px' }} />
                </div>
            ))}
        </div>
    );
}

export default CategoryTreeSkeleton;
